import type { DetailedImage, Image, Pet } from '@rover/types';
import { AdditionalDetailsValues } from '@rover/types/src/Pet';

export const cleanPetDetails = (pet: Pet): Pet => {
  const cleanedPetDetails = pet.petDetails.map((petDetail) => {
    if (!AdditionalDetailsValues.includes(petDetail.value)) {
      return { ...petDetail, additionalInformation: '' };
    }

    return petDetail;
  });
  return { ...pet, petDetails: cleanedPetDetails };
};

export const canDeleteImage = (image: Image | DetailedImage, currentUserOpk: string): boolean => {
  if (currentUserOpk && image && 'uploader' in image && image.uploader) {
    return image.uploader?.opk === currentUserOpk;
  }
  return true;
};
